module.exports = __webpack_public_path__ + "static/media/content-marketing.59c3da67.svg";